var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.2 957.3c-60.3 0-118.9-11.8-174-35.1-53.2-22.5-101-54.7-142.1-95.8-41-41-73.3-88.8-95.8-142.1-23.3-55.1-35.1-113.7-35.1-174s11.8-118.9 35.1-174c22.5-53.2 54.7-101 95.8-142.1 41-41 88.8-73.3 142.1-95.8 55.1-23.3 113.7-35.1 174-35.1s118.9 11.8 174 35.1c53.2 22.5 101 54.7 142.1 95.8 41 41 73.3 88.8 95.8 142.1 23.3 55.1 35.1 113.7 35.1 174s-11.8 118.9-35.1 174c-22.5 53.2-54.7 101-95.8 142.1-41 41-88.8 73.3-142.1 95.8-55.1 23.2-113.7 35.1-174 35.1z m0-830c-102.3 0-198.5 39.8-270.8 112.2C170 311.8 130.2 408 130.2 510.3S170 708.7 242.4 781.1c72.3 72.3 168.5 112.2 270.8 112.2S711.7 853.4 784 781.1c72.3-72.3 112.2-168.5 112.2-270.8 0-102.3-39.8-198.5-112.2-270.8-72.3-72.4-168.5-112.2-270.8-112.2z",
    fill: "#3B086B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 417.8c1-34.6 5-60.8 12.2-78.8 7.2-18 18.7-34.1 34.6-48.2 15.8-14.2 33.5-24.6 52.9-31.3 19.4-6.7 40-10.1 61.6-10.1 43.7 0 80 12.8 109.1 38.5 29 25.7 43.6 59.9 43.6 102.6 0 19.2-3.7 36.6-11.2 52.2-7.4 15.6-23.3 35-47.5 58.3-24.2 23.3-40.3 39.8-48.2 49.7-7.9 9.8-13.9 21.6-18 35.3-4.1 13.7-5.9 32-5.4 55.1h-63.4c0-26.9 2.2-48.4 6.5-64.4 4.3-16.1 10.8-30.1 19.4-42.1 8.6-12 24.2-29.6 46.8-52.9 22.6-23.3 37.1-40.2 43.6-50.8 6.5-10.6 9.7-26.3 9.7-47.2 0-20.9-7.4-39.4-22.3-55.4-15-16.2-36.6-24.3-64.9-24.3-63.8 0-95.8 37.9-95.8 113.8H350z m188.6 355h-69.8v-73.4h69.8v73.4z",
    fill: "#3B086B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0a887b9d65010cead51e66d30605a5f1.svg";
export { ForwardRef as ReactComponent };